import * as React from 'react'
import { FlatMonth, TimelineIndex } from '../GalleryView/timelineIndex'
import { useDateScrubber } from './DateScrubber.hook'

export interface DateScrubberProps {
  timeline: TimelineIndex
  /** current scroll position of the gallery, 0..1 */
  fraction: number
  onJump: (month: FlatMonth) => void
  isIndexLoaded?: (flatIndex: number) => boolean
}

export const DateScrubber: React.FC<DateScrubberProps> = ({
  timeline,
  fraction,
  onJump,
  isIndexLoaded,
}) => {
  const { railRef, visible, yearMarks, pill, indicatorFraction, isDragging, railHandlers } =
    useDateScrubber({ timeline, fraction, onJump, isIndexLoaded })

  if (!visible) return null

  return (
    <div
      {...railHandlers}
      className="fixed bottom-0 right-0 top-16 z-30 w-8 cursor-pointer select-none"
      style={{ touchAction: 'none' }}
    >
      {/* inset track: keeps the edge labels (half-translated) inside the rail */}
      <div ref={railRef} className="absolute inset-x-0 bottom-3 top-3">
        {yearMarks.map((mark) =>
          mark.showLabel ? (
            <span
              key={mark.key}
              className="absolute right-2 -translate-y-1/2 text-[10px] leading-none text-gray-500"
              style={{ top: `${mark.topFraction * 100}%` }}
            >
              {mark.key}
            </span>
          ) : (
            <span
              key={mark.key}
              className="absolute right-3 h-1 w-1 -translate-y-1/2 rounded-full bg-gray-300"
              style={{ top: `${mark.topFraction * 100}%` }}
            />
          )
        )}

        <div
          className={`absolute right-0 h-1 w-5 -translate-y-1/2 rounded-l bg-indigo-600 transition-opacity ${
            isDragging ? 'opacity-100' : 'opacity-70'
          }`}
          style={{ top: `${indicatorFraction * 100}%` }}
        />

        {pill && (
          <div
            className="pointer-events-none absolute right-9 -translate-y-1/2 whitespace-nowrap rounded-full bg-gray-900 px-3 py-1 text-xs text-white shadow"
            style={{ top: `${pill.topFraction * 100}%` }}
          >
            {pill.label}
          </div>
        )}
      </div>
    </div>
  )
}
